import React from 'react'
import { Box, Typography } from '@mui/material'

const FallbackCustomView = ({ message }) => {
  return (
    <Box
      id="fallback-comp"
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '6px',
        backgroundColor: 'background.paper',
        px: 1.5,
        py: 0.75,
        boxSizing: 'border-box',
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          fontSize: '14px',
          textAlign: 'center',
        }}
      >
        {message || 'Module not available'}
      </Typography>
    </Box>
  )
}

export default FallbackCustomView
